import {
  providerManagementApi,
  useDeleteProviderMutation,
  useTransferMediaOwnershipMutation,
} from '../api'

export const useLoading = () => {
  const { isFetching: providersLoading } =
    providerManagementApi.endpoints.getAllProviders.useQueryState()
  const [, { isLoading: transferLoading }] = useTransferMediaOwnershipMutation({
    fixedCacheKey: 'transfer-media',
  })
  const [, { isLoading: deleteLoading }] = useDeleteProviderMutation({
    fixedCacheKey: 'delete-provider',
  })

  return {
    providersLoading,
    transferLoading,
    deleteLoading,
    loading: providersLoading || transferLoading || deleteLoading,
  }
}
